import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3fe0bc09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-content" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "error-content" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "error-content" }
const _hoisted_8 = { class: "wrapper" }
const _hoisted_9 = { class: "error-content" }
const _hoisted_10 = { class: "wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-content-text sans" }, " お探しのページは見つかりませんでした。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_wrapper = _resolveComponent("page-wrapper")!
  const _component_center = _resolveComponent("center")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.error === undefined || Number(_ctx.error) === 0)
    ? (_openBlock(), _createBlock(_component_page_wrapper, {
        key: 0,
        title: _ctx.title,
        "show-header-logo": _ctx.showHeaderLogo !== 'false' && Boolean(_ctx.showHeaderLogo),
        "show-head-in": _ctx.showHeadIn !== 'false' && Boolean(_ctx.showHeadIn),
        "show-head-button": _ctx.showHeadButton !== 'false' && Boolean(_ctx.showHeadButton),
        "hide-magazine-form": _ctx.hideMagazineForm !== 'false' && Boolean(_ctx.hideMagazineForm),
        top: _ctx.top !== 'false' && Boolean(_ctx.top)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["title", "show-header-logo", "show-head-in", "show-head-button", "hide-magazine-form", "top"]))
    : (Number(_ctx.error) === 503)
      ? (_openBlock(), _createBlock(_component_page_wrapper, {
          key: 1,
          title: _ctx.titleFromApi || 'アクセスが集中しております',
          class: "error"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.message || '只今、アクセスが集中しております。/nしばらく経ってからお試しください。').split('/n'), (row) => {
                  return (_openBlock(), _createBlock(_component_center, { key: row }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row), 1),
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : (Number(_ctx.error) === 500)
        ? (_openBlock(), _createBlock(_component_page_wrapper, {
            key: 2,
            title: _ctx.titleFromApi || 'エラーが発生しました',
            class: "error"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.message || 'エラーが発生しました。/nしばらく経ってからお試しください。').split('/n'), (row) => {
                    return (_openBlock(), _createBlock(_component_center, { key: row }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row), 1),
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]))
        : (Number(_ctx.error) === 5000)
          ? (_openBlock(), _createBlock(_component_page_wrapper, {
              key: 3,
              title: "在庫が確保できませんでした",
              class: "error"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_center, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" ご希望の車両の在庫が確保できませんでした。 ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_center, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: "/",
                          class: "link-btn sans error-btn"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" TOPへ ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_page_wrapper, {
              key: 4,
              title: "ページが見つかりませんでした",
              class: "error"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_center, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: "/",
                          class: "link-btn sans error-btn"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" TOPへ ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }))
}